import script from "./HeroDasboard.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroDasboard.vue?vue&type=script&setup=true&lang=js"

import "./HeroDasboard.vue?vue&type=style&index=0&id=6cdeb07f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cdeb07f"]])

export default __exports__